import { Injectable } from '@angular/core';
import * as _ from 'underscore';

@Injectable()
export class OutNAboutCommands {
    private baseCommand:object = {
        "cmd_msg": {
            "msg_id": null,
            "timestamp": null,
            "cmd": null
        }
    };

    addUserCmd (message) {
        var addUserCmd = _.clone(this.baseCommand);
        addUserCmd["cmd"] = "add_user";
        addUserCmd["user_id"] = message.i;
        addUserCmd["first_name"] = message.s;
        addUserCmd["last_name"] = message.m;
        addUserCmd["password"] = "Mobile";
        addUserCmd["is_administrator"] = "Mobile";
        addUserCmd["is_receptionist"] = "Mobile";
        addUserCmd["dept_id"] = "Mobile";

        return addUserCmd;
    }

    deleteUserCmd (message) {
        var deleteUserCmd = _.clone(this.baseCommand);
        deleteUserCmd["cmd"] = "delete_user";
        deleteUserCmd["user_id"] = message.i;

        return deleteUserCmd;
    }

    setUserStatusCmd (message) {
        var userStatusCmd = {
            cmd: "set_user_status",
            user_id: message.i,
            status: message.s,
            status_message: message.m,
            change_type: "P"
        };
        
        return userStatusCmd;
    }

    setUserPrivilegesCmd (message) {
        var userPrivilegeCmd = _.clone(this.baseCommand);
        userPrivilegeCmd["cmd"] = "set_user_permissions";
        userPrivilegeCmd["user_id"] = message.i;
        userPrivilegeCmd["is_administrator"] = message.a;
        userPrivilegeCmd["is_receptionist"] = message.r;

        return userPrivilegeCmd;
    }

    setUserPasswordCmd (message) {
        var setPasswordCmd = _.clone(this.baseCommand);
        setPasswordCmd["cmd"] = "set_user_privleges";
        setPasswordCmd["user_id"] = message.i;
        setPasswordCmd["old_password"] = message.s;
        setPasswordCmd["new_password"] = message.m;

        return setPasswordCmd;
    }

    resetUserPasswordCmd (message) {
        var resetPasswordCmd = _.clone(this.baseCommand);
        resetPasswordCmd["cmd"] = "reset_user_password";
        resetPasswordCmd["user_id"] = message.i;
        resetPasswordCmd["new_password"] = message.password;

        return resetPasswordCmd;
    }

    setUserNameCmd (message) {
        var setUsernameCmd = _.clone(this.baseCommand);
        setUsernameCmd["cmd"] = "set_user_name";
        setUsernameCmd["user_id"] = message.i;
        setUsernameCmd["first_name"] = message.f;
        setUsernameCmd["last_name"] = message.n;

        return setUsernameCmd;
    }

    setUserDepartmentCmd (message) {
        var setDepartmentCmd = _.clone(this.baseCommand);
        setDepartmentCmd["cmd"] = "set_user_department";
        setDepartmentCmd["user_id"] = message.i;
        setDepartmentCmd["dept_id"] = message.d;

        return setDepartmentCmd;
    }

    addDepartmentCmd (message) {
        var addDepartmentCmd = _.clone(this.baseCommand);
        addDepartmentCmd["cmd"] = "add_department";
        addDepartmentCmd["dept_name"] = message;

        return addDepartmentCmd;
    }

    renameDepartmentCmd (message) {
        var renameDepartmentCmd = _.clone(this.baseCommand);
        renameDepartmentCmd["cmd"] = "rename_department";
        renameDepartmentCmd["dept_id"] = message.i;
        renameDepartmentCmd["dept_name"] = message.n;
        
        return renameDepartmentCmd;
    }

    deleteDepartmentCmd (message) {
        var deleteDepartmentCmd = _.clone(this.baseCommand);
        deleteDepartmentCmd["cmd"] = "delete_department";
        deleteDepartmentCmd["dept_id"] = message.i;
        
        return deleteDepartmentCmd;
    }

    getStatusHistoryReportCmd (message) {
        var getStatusHistoryReportCmd = _.clone(this.baseCommand);
        getStatusHistoryReportCmd["cmd"] = "status_history_report";
        getStatusHistoryReportCmd["start_date"] = message.start_date;
        getStatusHistoryReportCmd["end_date"] = message.end_date;
        
        if (message.dept_id) {
            getStatusHistoryReportCmd["dept_id"] = message.dept_id;
        }
        if (message.user_id) {
            getStatusHistoryReportCmd["user_id"] = message.user_id;
        }

        return getStatusHistoryReportCmd;
    }

    // Resources
    addResourceCmd (message) {
        var addResourceCmd = _.clone(this.baseCommand);
        addResourceCmd["cmd"] = "add_resource";
        addResourceCmd["name"] = message.name;
        addResourceCmd["dept_id"] = message.dept_id;

        return addResourceCmd;
    }

    deleteResourceCmd (message) {
        var deleteResourceCmd = _.clone(this.baseCommand);
        deleteResourceCmd["cmd"] = "delete_recource";
        deleteResourceCmd["resource_id"] = message.i;

        return deleteResourceCmd;
    }

    renameResourceCmd (message) {
        var renameResourceCmd = _.clone(this.baseCommand);
        renameResourceCmd["cmd"] = "rename_resource";
        renameResourceCmd["resource_id"] = message.i;
        renameResourceCmd["name"] = message.n;

        return renameResourceCmd;
    }

    setResourceDeptCmd (message) {
        var setResourceDeptCmd = _.clone(this.baseCommand);
        setResourceDeptCmd["cmd"] = "set_resource_department";
        setResourceDeptCmd["resource_id"] = message.i;
        setResourceDeptCmd["dept_id"] = message.d;

        return setResourceDeptCmd;
    }

    setResourceStatusCmd (message) {
        var setResourceStatusCmd = _.clone(this.baseCommand);
        setResourceStatusCmd["cmd"] = "set_resource_status";
        setResourceStatusCmd["resource_id"] = message.i;
        setResourceStatusCmd["status"] = message.s;
        setResourceStatusCmd["status_message"] = message.m;

        return setResourceStatusCmd;
    }

    // CUSTOM FIELDS
    addCustomFieldCmd (message) {
        var addCustomFieldCmd = _.clone(this.baseCommand);
        addCustomFieldCmd["cmd"] = "add_custom_field";
        addCustomFieldCmd["name"] = message.name;

        return addCustomFieldCmd;
    }

    deleteCustomFieldCmd (message) {
        var deleteCustomFieldCmd = _.clone(this.baseCommand);
        deleteCustomFieldCmd["cmd"] = "delete_custom_field";
        deleteCustomFieldCmd["field_id"] = message.i;

        return deleteCustomFieldCmd;
    }

    renameCustomFieldCmd (message) {
        var renameCustomFieldCmd = _.clone(this.baseCommand);
        renameCustomFieldCmd["cmd"] = "rename_custom_field";
        renameCustomFieldCmd["field_id"] = message.i;
        renameCustomFieldCmd["name"] = message.n;

        return renameCustomFieldCmd;
    }

    setUserCustomFieldCmd (message) {
        var setUserCustomFieldCmd = _.clone(this.baseCommand);
        setUserCustomFieldCmd["cmd"] = "set_user_custom_field";
        setUserCustomFieldCmd["user_id"] = message.i;
        setUserCustomFieldCmd["field_id"] = message.d;
        setUserCustomFieldCmd["value"] = message.v;

        return setUserCustomFieldCmd;
    }
}



// WEBPACK FOOTER //
// ./src/providers/ona-commands.ts